<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button> -->
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "ACCEPTED_STUDENT" | translate
                    | titlecase }} - {{ "ENROLLMENT_STATUS" | translate | titlecase }} : </h5>
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;color:Green;"> {{enrollmentStatus}}
                </h5>
                <hr style="clear:both;" />
                <app-loader [show]="showLoader"></app-loader>

                <div style="text-align: center;font-size: 16px;font-weight: bold;" *ngIf="false">Show message here if
                    enrollment is finilizes</div>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <!-- <div class="card-header" id="headingOne" style="padding: 3px;">
                            <h5 class="mb-0"
                                style="text-align: center;font-weight:bold;text-align: center;font-weight: bold;">
                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne" style="width: 100%;">
                                    {{"ADVANCED_SEARCH" | translate | titlecase }}
                                    <i class="fas fa-filter"></i>
                                </button>
                            </h5>
                        </div> -->

                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="orderingForm" (change)="orderingFormChange()"
                                    (submit)="orderingFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-5">
                                            <label class="font-bold">{{ "ORDER_BY" | translate | titlecase }}</label>
                                            <select class="form-control" formControlName="orderByField">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of orderByFields" [ngValue]="field.key">
                                                    {{field.value}}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="orderingForm.controls.orderByField.touched && orderingForm.controls.orderByField.invalid && orderingForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-4">
                                            <label class="font-bold">{{ "ORDER_TYPE" | translate | titlecase }}</label>
                                            <select class="form-control" formControlName="orderType">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let orderType of orderTypes" [ngValue]="orderType.key">
                                                    {{
                                                    orderType.value
                                                    }}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="orderingForm.controls.orderType.touched && orderingForm.controls.orderType.invalid && orderingForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-4"
                                            style="padding-top: 23px;padding-left: 0px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "ORDER" | translate | titlecase }}</button>
                                        </div>
                                    </div>
                                </form>
                                <hr />
                                <div class="row">
                                    <div class="col-md-2 form-group">
                                        <button type="button" (click)="reloadCandidates()" class="btn btn-primary"
                                            *ngIf="! enrolmentFinalizedFlag">
                                            {{ "RELOAD_CANDIDATES" | translate | titlecase }}</button>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <button type="button" (click)="checkForNewCandidates()" class="btn btn-primary"
                                            *ngIf="! enrolmentFinalizedFlag">
                                            {{ "CHECK_FOR_NEW_CANDIDATES" | translate | titlecase }}</button>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <button type="button" (click)="getLastMatNumber()" class="btn btn-info"
                                            *ngIf="! enrolmentFinalizedFlag">
                                            {{ "GENERATE_MAT_NUMBER" | translate | titlecase }}</button>
                                    </div>
                                    <div class="col-md-1.5 form-group">
                                        <button type="button" (click)="applyStudentsUpdate()" class="btn btn-success"
                                            *ngIf="! enrolmentFinalizedFlag">
                                            {{ "APPLY_UPDATES" | translate | titlecase }}</button>
                                    </div>
                                    <div class="col-md-2 form-group">
                                        <!-- finalizeEnrollmentButtonView && -->
                                        <button type="button" data-toggle="modal" data-target="#finalizeEnrollmentModal"
                                            class="btn btn-warning" *ngIf=" (! enrolmentFinalizedFlag)">
                                            {{ "FINALIZE_ENROLLMENT" | translate | titlecase }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <div style="height: 500px; overflow-y: scroll;">
                        <table *ngIf="students.length >= 1" class="table-striped" data-sticky-header="true"
                            id="datatable">
                            <thead style="    position: sticky; top: 0; background: white;">
                                <tr>
                                    <th>{{ "NO" | translate | titlecase }}</th>
                                    <!-- <th>{{ "MAT_NO" | translate | titlecase }}</th> -->
                                    <th>{{ "SERIAL_No" | translate | titlecase }}</th>
                                    <th>{{ "MAT_NO" | translate | titlecase }}</th>

                                    <th>{{ "FULL_NAME_ARABIC" | translate | titlecase }}</th>
                                    <th>{{ "FIRST_NAME_AR" | translate | titlecase }}</th>
                                    <th>{{ "LAST_NAME_AR" | translate | titlecase }}</th>

                                    <th>{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</th>
                                    <th>{{ "FIRST_NAME_EN" | translate | titlecase }}</th>
                                    <th>{{ "LAST_NAME_EN" | translate | titlecase }}</th>
                                    
                                    <th>{{ "ACADEMIC_YEAR" | translate | titlecase }}</th>
                                    <th>{{ "SEMESTER" | translate | titlecase }}</th>
                                    <!-- <th>{{ "BATCH" | translate | titlecase }}</th>-->
                                    <th>{{ "GENDER" | translate | titlecase }}</th> 

                                    <th>{{ "EMAIL" | translate | titlecase }}</th>
                                    <th>{{ "PHONE_Number" | translate | titlecase }}</th>
                                    <th>{{ "ADDRESS" | translate | titlecase }}</th>
                                    <th>{{ "NATIONAL_ID" | translate | titlecase }}</th>
                                    <th>{{ "PICTURE" | translate | titlecase }}</th>
                                    <th class="border-0 font-14 px-2 text-grey">{{ "EDIT" | translate | titlecase
                                        }}</th>
                                    <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of students let i = index">
                                    <td>{{res?.no}}</td>
                                    <!-- <td>{{res?.matNo}}</td> -->
                                    <td>{{res?.serialno}}</td>
                                    <td>{{res?.stuCode}}</td>

                                    <td>{{res?.fullNameAr}}</td>
                                    <td>{{res?.firstNameAr}}</td>
                                    <td>{{res?.lastNameAr}}</td>

                                    <td>{{res?.fullNameEn}}</td>
                                    <td>{{res?.firstNameEn}}</td>
                                    <td>{{res?.lastNameEn}}</td>

                                    <td>{{(globals.lang == 'ar')? res.yearNameAr : res.yearNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? res.semesterNameAr : res.semesterNameEn}}</td>
                                    <!-- <td>{{ "BATCH" | translate | titlecase }}</td>
                                    <td>{{ "GENDER" | translate | titlecase }}</td> -->

                                    <td>{{ res?.gender == "M"? ("MALE" | translate | titlecase) :
                                        ("FEMALE" | translate |
                                        titlecase) }}</td>

                                    <td>{{res?.email}}</td>
                                    <td>{{res?.mobileNo}}</td>
                                    <td>{{res?.address}}</td>
                                    <td>{{res?.nidNo}}</td>
                                    <td class="cursor-pointer">
                                        <img src="{{photoPath+ res?.photoFilename}}"
                                            onerror="this.src ='assets/images/stud-image.png';" alt="Photo"
                                            class="img-fluid" width="70" id="userImageTag" (load)="getBase64($event, i)"
                                            crossOrigin='Anonymous'>
                                    </td>
                                    <td class="text-bold text-warning">
                                        <!-- <a class="btn btn-sm btn-link text-warning" routerLink="/enrolment/update-course"
                                            [queryParams]="{studentId: res?.id}"><i class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</a> routerLink="#deleteModal" -->
                                        <a class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                            data-target="#EditAcceptCand" (click)="editCand(res?.id)"><i
                                                class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</a>
                                    </td>
                                    <!-- <td class="text-bold text-warning" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">
                                        <button class="btn btn-sm btn-link text-warning" (click)="editCourse(res?.id)"><i
                                                class="fas fa-edit"></i>
                                                {{ "MODIFY" | translate | titlecase }}</button>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="EditAcceptCand" tabindex="-1" aria-labelledby="EditAcceptCand" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" id="EditAcceptCandContainer">
        <form class="modal-content col-md-12" [formGroup]="modifyForm" (submit)="editCandSubmit()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "MODIFY_ACCEPT_CAND" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "FULL_NAME_ARABIC" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="fullNameAr">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.fullNameAr.touched && modifyForm.controls.fullNameAr.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "FIRST_NAME_AR" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="firstNameAr">
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.firstNameAr.touched && modifyForm.controls.firstNameAr.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "LAST_NAME_AR" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="lastNameAr">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.lastNameAr.touched && modifyForm.controls.lastNameAr.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>


                </div>
                <div class="row">
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="fullNameEnglish">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.fullNameEnglish.touched && modifyForm.controls.fullNameEnglish.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "FIRST_NAME_EN" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="firstNameEn">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.firstNameEn.touched && modifyForm.controls.firstNameEn.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "LAST_NAME_EN" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="lastNameEn">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.lastNameEn.touched && modifyForm.controls.lastNameEn.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>


                </div>
                <div class="row">
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold"> {{ "GENDER" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="gender">
                            <option [ngValue]="">>{{ "SELECT" | translate | titlecase }}</option>
                            <option value="M">{{ "MALE" | translate | titlecase }}</option>
                            <option value="F">{{ "FEMALE" | translate | titlecase }}</option>
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.gender.touched && modifyForm.controls.gender.invalid && modifyForm.dirty">
                            {{"PLEASE_SELECT_A_GENDER" | translate | titlecase}}
                        </div>
                    </div>

                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "EMAIL" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="email">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.email.touched && modifyForm.controls.email.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>

                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "PHONE_Number" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="phoneNumber">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.phoneNumber.touched && modifyForm.controls.phoneNumber.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ADDRESS" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="address">
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.address.touched && modifyForm.controls.address.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "NATIONAL_ID" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="nationalId" readonly>

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.nationalId.touched && modifyForm.controls.nationalId.invalid && modifyForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>

                    </div>
                    <div class="col-md-4 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "PICTURE" | translate | titlecase }}</label>
                        <input type="file" class="form-control" formControlName="picture"
                            (change)="candChangeImage($event)">
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="modifyForm.controls.picture.touched && modifyForm.controls.picture.invalid && modifyForm.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>

                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-EditAcceptCand" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>

<div class="modal fade" id="finalizeEnrollmentModal" tabindex="-1" aria-labelledby="finalizeEnrollmentModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="submitFinalizeEnrollment()"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>